const styles = (theme) => ({
  root: {
    borderRadius: theme.spacing(2),
    width: '100%',
    height: 'auto',
    backgroundColor: theme.palette.background.default,
  },
  roundedTextField: {
    [`& fieldset`]: {
      borderRadius: theme.spacing(4),
    },
    backgroundColor: theme.palette.background.paper,
  },
  backButton: {
    backgroundColor: theme.palette.background.paper,
    border: 0,
    color: theme.palette.black,
  },
  roundedButton: {
    borderRadius: theme.spacing(4),
  },
})

export default styles
